import { axios, Headers } from "../../../@core/auth/jwt/jwtService"
import themeConfig from "../../../configs/themeConfig"
import {
    httpManageAdminData,
    httpManageAdminEditData,
    toUploadFile,
    httpDataForDashboard,
    httppostSound,
    httpGetArtistSound,
    httpPostCategory,
    httpPostUpdateCategory,
    httpGetCategory,
    httpGetAllUsers, httpGetUserById,
    httpPostDeleteUser,
    httpGetAllSound,
    httpPostUseSound,
    httpPostApproveByArtist,
    httpPostApproveByAdmin,
    httpGetApprovalById,
    httpGetApprovals,
    httpPostCreateBrandRequest,
    httpGetBrandRequests,
    httpGetAllBrandRequests,
    httpPostUser,
    httpGetArtistDashbord,
    httpPostVerifyFollowers,
    httpPostApplyBrand,
    httpGetArtistSoundWithLocking,
    httpGetBrandRequestsWithLocking,
    httpGetAllTransactions,
    httpPostWithdrawtoBank,
    httpPostFundUserWallet,
    httpPostApproveAllByArtist,
    httpPostAddClick,
    httpGetUserInfo,
    httpGetUserByEmail,
    httpPostEmail,
    httpGetUserByResetCode,
    httpPostResetPassword,
    httpPostAccountApprovalStatus,
    httpPostCheckClickAndPendingReq,
    httpGetUsersWithPendingApprovals,
    httpGetNotifications,
    httpPostAccountInfluencerStatus,
    httpPostAccountTenkApprovalStatus,
    httpPostDeleteSound,
    httpPostAddHoldSlot,
    httpGetReservedSlots,
    httpGetReservedSlots as httpGetReservedSlotsForBrand,
    httpGetDashboardNew,
    httpPostUpdateAccoountType,
    httpPostMakeSpecialAccount,
    httpPostDeleteReservedSlots,
    httpPostUpdateUserEmail,
    httpGetArtistSoundById,
    httppostAddMoreVideostoSound,
    httpPostUpdateUserSpamVideosStatus,
    httpGetArtistSpamSounds,
    httpGetArtistSpamSoundSlots,
    httpPostHoldSpamSoundSlots,
    httpPostSubmitSpamSoundLinks,
    httpPostSpamSoundApprovalByAdmin,
    httpGetAllSpamSoundSlots,
    httpGetTiktokerRejectedVideos,
    httpPostResetUserBankAccount,
    httpPostUpdateCronJobStatus,
    httpGetCronJobStatus,
    httpPostUpdateUserBrandStatus,
    httpPostAddBrandApplicationInfo,
    httpGetUserBrandApplication,
    httpGetAllBrandApplications,
    httpUpdateBrandApplicationStatus,
    httpGetServiceExamples,
    httpPostAddServiceExample,
    httpPostUpdateServiceExample,
    httpPostDeleteServiceExample,
    httpPostCreateServiceOrder,
    httpGetAdminServiceOrders,
    httpPostUpdateServiceOrderStatus

} from './ManageConstants'



// POST
const postManageHOF = (manageApi, data, id) => {

    let URL = localStorage.getItem('baseURL')
    if (!URL) {
        URL = themeConfig.app.baseURLs
    }
    if (id) { return axios.post(`${URL}${manageApi}?id=${id}`, data, Headers) }

    return axios.post(`${URL}${manageApi}`, data, Headers)
}

const postPaymentHOF = (manageApi, data, id) => {
    return axios.post(`https://walletapi.paytok.com.ng${manageApi}`, data, Headers)
}

// GET
// Get Manage HOF
const getManageHOF = (manageApi) => {

    let URL = localStorage.getItem('baseURL')
    if (!URL) {
        URL = themeConfig.app.baseURLs
    }
    return axios.get(`${URL}${manageApi}`, Headers)
}


//  Admin POST
const postManageEditAdminData = (data, id) => postManageHOF(httpManageAdminEditData, data, id)

const uploadFile = (data, id) => postManageHOF(toUploadFile, data, id)


//  admin GET
const getManageAdminData = () => getManageHOF(httpManageAdminData)
//  agent GET


const postNewSound = (data, id) => postManageHOF(httppostSound, data)
const postAddMoreVideostoSound = (data, id) => postManageHOF(httppostAddMoreVideostoSound, data)
const getUserWallet = (data, id) => postManageHOF(`/auth/get-user-wallet?user_id=${data.uid}`, data)
const postCreateBrandRequest = (data, id) => postManageHOF(httpPostCreateBrandRequest, data)
const getBrandRequest = (data) => getManageHOF(httpGetBrandRequests + `?brand_id=${data.brand_id}&type=${data.type}`)
const getBrandRequestWithLocking = (page) => getManageHOF(httpGetBrandRequestsWithLocking + `?page=${page}`)
const getAllBrandRequest = () => getManageHOF(httpGetAllBrandRequests)

// Data for Dashboard
const getDataForDashboard = () => getManageHOF(httpDataForDashboard)


//PAYTOK
const getArtistSound = (artist_id) => getManageHOF(httpGetArtistSound + `?artist_id=${artist_id}`)
const getArtistSoundById = (artist_id) => getManageHOF(httpGetArtistSoundById + `?soundid=${artist_id}`)
const getArtistSoundWithLocking = (page, curpage) => getManageHOF(httpGetArtistSoundWithLocking + `?page=${page}&curpage=${curpage}`)
const getArtistSpamSounds = (page, curpage) => getManageHOF(httpGetArtistSpamSounds + `?page=${page}&curpage=${curpage}`)
const getAllSound = (artist_id) => getManageHOF(httpGetAllSound)
const postCreateCategory = (data) => postManageHOF(httpPostCategory, data)
const postUpdateCategory = (data) => postManageHOF(httpPostUpdateCategory, data)
const getAllCategories = (data) => getManageHOF(httpGetCategory)
const getAllUsers = (data) => getManageHOF(httpGetAllUsers)
const getUserById = (data) => getManageHOF(httpGetUserById + `?userid=${data.userid}`)
const getUserInfo = () => getManageHOF(httpGetUserInfo)
const postDeleteUser = (data) => postManageHOF(httpPostDeleteUser, { uid: data })
const postUseSound = (data) => postManageHOF(httpPostUseSound, data)
const postUpdateUserEmail = (data) => postManageHOF(httpPostUpdateUserEmail, data)
const postApprovalByArtist = (data) => postManageHOF(httpPostApproveByArtist, data)
const postApprovalAllByArtist = (data) => postManageHOF(httpPostApproveAllByArtist, data)
const postApprovalByAdmin = (data) => postManageHOF(httpPostApproveByAdmin, data)
const getApprovalById = (data, role) => getManageHOF(httpGetApprovalById + `?artist_id=${data}&role=${role}`)
const getApprovals = (data) => getManageHOF(httpGetApprovals + `?user_id=${data}`)
const postUser = (data) => postManageHOF(httpPostUser, data)
const getArtistDashboard = (data) => getManageHOF(httpGetArtistDashbord + `?user_id=${data.user_id}`)
const postVerifyFollowers = (data) => postManageHOF(httpPostVerifyFollowers, data)
const postApplyBrand = (data) => postManageHOF(httpPostApplyBrand, data)
const postApproveAllUsers = (data) => postManageHOF(`/auth/approve-all-user-accounts`, data)

//wallet apis
const postCreateWallet = (data) => postPaymentHOF('/create', data)
const postAddBankAccountInit = (data) => postManageHOF('/auth/bank-add-init', data)
const postAddBankAccount = (data) => postManageHOF('/auth/bank-add', data)
const postWithdrawtoBank = (data) => postManageHOF(httpPostWithdrawtoBank, data)
const getBankList = (data) => getManageHOF('/auth/get-banks-list?user_id=' + data.user_id)
const getAllTransactions = (data) => getManageHOF(httpGetAllTransactions)
const postFundUserWallet = (data) => postManageHOF(httpPostFundUserWallet, data)
const postAddClicks = (data) => postManageHOF(httpPostAddClick, data)
const getUserByEmail = (data) => getManageHOF(httpGetUserByEmail + `?email=${data.email}`)
const postResetEmail = (data) => postManageHOF(httpPostEmail, data)
const postResetPassword = (data) => postManageHOF(httpPostResetPassword, data)
const getUserByResetCode = (data) => getManageHOF(httpGetUserByResetCode + `?code=${data.code}`)
const updateAccountApprovalStatus = (data) => postManageHOF(httpPostAccountApprovalStatus, data)
const updateAccountInfluencerStatus = (data) => postManageHOF(httpPostAccountInfluencerStatus, data)
const updateAccountTenkApprovalStatus = (data) => postManageHOF(httpPostAccountTenkApprovalStatus, data)
const checkClicksandPendingRequests = (data) => postManageHOF(httpPostCheckClickAndPendingReq, data)
const postDeleteSound = (data) => postManageHOF(httpPostDeleteSound, data)
const getUsersWithPendingRequests = (data) => getManageHOF(httpGetUsersWithPendingApprovals)
const getUsersNotifications = (data) => getManageHOF(httpGetNotifications + `?user_id=${data}`)
const holdSlot = (data) => postManageHOF(httpPostAddHoldSlot, data)
const getSoundReservedSlots = (data) => getManageHOF(httpGetReservedSlots + `?sound_id=${data}`)
const getDashboardNew = (data) => getManageHOF(httpGetDashboardNew + `?startdate=${data.startdate}&enddate=${data.enddate}`)

const postUpdateAccountType = (data) => postManageHOF(httpPostUpdateAccoountType, data)
const postMakeSpecialAccount = (data) => postManageHOF(httpPostMakeSpecialAccount, data)
const postUpdateUserSpamVideosStatus = (data) => postManageHOF(httpPostUpdateUserSpamVideosStatus, data)
const postUpdateUserBrandStatus = (data) => postManageHOF(httpPostUpdateUserBrandStatus, data)
const postDeleteReservedSlots = (data) => postManageHOF(httpPostDeleteReservedSlots, data)


const getArtistSpamSoundSlots = (data) => getManageHOF(httpGetArtistSpamSoundSlots + `?soundid=${data.soundid}`)
const getAllSpamSoundSlots = (data) => getManageHOF(httpGetAllSpamSoundSlots)
const postHoldSpamSoundSlot = (data) => postManageHOF(httpPostHoldSpamSoundSlots, data)
const postSubmitSpamSoundLinks = (data) => postManageHOF(httpPostSubmitSpamSoundLinks, data)
const postSpamSoundApprovalByAdmin = (data) => postManageHOF(httpPostSpamSoundApprovalByAdmin, data)
const postResetUserBankAccount = (data) => postManageHOF(httpPostResetUserBankAccount, data)
const postUpdateCronJobStatus = (data) => postManageHOF(httpPostUpdateCronJobStatus, data)
const getCronJobStatus = (data) => postManageHOF(httpGetCronJobStatus)
const getTiktokersRejectedVideos = (data) => getManageHOF(httpGetTiktokerRejectedVideos)
const getUserBrandApplication = (data) => getManageHOF(httpGetUserBrandApplication)
const postAddBrandApplicationInfo = (data) => postManageHOF(httpPostAddBrandApplicationInfo, data)
const getAllBrandApplications = () => getManageHOF(httpGetAllBrandApplications)
const updateBrandApplicationStatus = (data) => postManageHOF(httpUpdateBrandApplicationStatus, data)

// UGC Project APIs
const createUGCProject = (data) => postManageHOF('/brand/create-ugc-project', data)
const getUGCProject = (id) => getManageHOF(`/brand/get-ugc-project?id=${id}`)
const assignCreatorsToProject = (data) => postManageHOF('/brand/assign-creators', data)
const getApprovedCreators = (filters) => getManageHOF('/brand/get-approved-creators' + (filters ? `?location=${filters.location || ''}&niche=${filters.niche || ''}&min_price=${filters.min_price || ''}&max_price=${filters.max_price || ''}` : ''))
const submitUGCRevision = (data) => postManageHOF('/brand/submit-revision', data)
const rateUGCCreator = (data) => postManageHOF('/brand/rate-creator', data)
const getBrandUGCProjects = (brand_user_id) => getManageHOF(`/brand/get-brand-ugc-projects?brand_user_id=${brand_user_id}`)

// Creator UGC APIs
const getUGCProjectsForCreator = (creator_user_id) => getManageHOF(`/artist/get-ugc-projects?creator_user_id=${creator_user_id}`)
const submitUGCVideoLink = (data) => postManageHOF('/artist/submit-ugc-video', data)
const updateCreatorProfile = (data) => postManageHOF('/artist/update-creator-profile', data)

// Chat APIs
const sendUGCChatMessage = (data) => postManageHOF('/chat/send-message', data)
const getUGCChatMessages = (project_creator_id) => getManageHOF(`/chat/get-messages?project_creator_id=${project_creator_id}`)
const getUGCProjectCreator = (id) => getManageHOF(`/artist/get-ugc-project-creator?id=${id}`)

// Service Examples APIs
const getServiceExamples = (service_type) => getManageHOF(httpGetServiceExamples + (service_type ? `?service_type=${service_type}` : ''))
const addServiceExample = (data) => postManageHOF(httpPostAddServiceExample, data)
const updateServiceExample = (data) => postManageHOF(httpPostUpdateServiceExample, data)
const deleteServiceExample = (data) => postManageHOF(httpPostDeleteServiceExample, data)

// Service Orders APIs
const createServiceOrder = (data) => postManageHOF(httpPostCreateServiceOrder, data)
const getServiceOrders = (service_type, status) => {
    let query = []
    if (service_type) query.push(`service_type=${service_type}`)
    if (status) query.push(`status=${status}`)
    const queryString = query.length > 0 ? `?${query.join('&')}` : ''
    return getManageHOF(httpGetAdminServiceOrders + queryString)
}
const updateServiceOrderStatus = (data) => postManageHOF(httpPostUpdateServiceOrderStatus, data)


export default {


    getManageAdminData,
    postManageEditAdminData,
    uploadFile,
    getUsersNotifications,

    getDataForDashboard,
    postNewSound,
    getArtistSound,
    postCreateCategory,
    postUpdateCategory,
    getAllCategories,
    getAllUsers,
    getUserById,
    getUserInfo,
    postDeleteUser,
    getAllSound,
    postUseSound,
    postApprovalByAdmin,
    postApprovalByArtist,
    getApprovalById,
    getApprovals,
    postCreateBrandRequest,
    getBrandRequest,
    getAllBrandRequest,
    postUser,
    getUserWallet,
    getArtistDashboard,
    postVerifyFollowers,
    postApplyBrand,
    postCreateWallet,
    postAddBankAccount,
    postAddBankAccountInit,
    getBankList,
    getArtistSoundWithLocking,
    getBrandRequestWithLocking,
    getAllTransactions,
    postWithdrawtoBank,
    postFundUserWallet,
    postApprovalAllByArtist,
    postAddClicks,
    getUserByEmail,
    postResetEmail,
    getUserByResetCode,
    postResetPassword,
    updateAccountApprovalStatus,
    checkClicksandPendingRequests,
    getUsersWithPendingRequests,
    updateAccountInfluencerStatus,
    updateAccountTenkApprovalStatus,
    postDeleteSound,
    holdSlot,
    getSoundReservedSlots,
    getDashboardNew,
    postUpdateAccountType,
    postMakeSpecialAccount,
    postDeleteReservedSlots,
    postUpdateUserEmail,
    getArtistSoundById,
    postAddMoreVideostoSound,
    postUpdateUserSpamVideosStatus,
    getArtistSpamSounds,
    getArtistSpamSoundSlots,
    postHoldSpamSoundSlot,
    postSubmitSpamSoundLinks,
    postSpamSoundApprovalByAdmin,
    getAllSpamSoundSlots,
    getTiktokersRejectedVideos,
    postResetUserBankAccount,
    postApproveAllUsers,
    postUpdateCronJobStatus,
    getCronJobStatus,
    postUpdateUserBrandStatus,
    postAddBrandApplicationInfo,
    getUserBrandApplication,
    getAllBrandApplications,
    updateBrandApplicationStatus,
    createUGCProject,
    getUGCProject,
    assignCreatorsToProject,
    getApprovedCreators,
    submitUGCRevision,
    rateUGCCreator,
    getBrandUGCProjects,
    getUGCProjectsForCreator,
    submitUGCVideoLink,
    updateCreatorProfile,
    sendUGCChatMessage,
    getUGCChatMessages,
    getUGCProjectCreator,
    getServiceExamples,
    addServiceExample,
    updateServiceExample,
    deleteServiceExample,
    createServiceOrder,
    getServiceOrders,
    updateServiceOrderStatus

}

